import React, { Component } from "react";

import { Table, Card, Row, Col, Form, Image, Button } from "react-bootstrap";
import ItemMasterAdd from "./ItemMasterAdd";
import ItemMasterEdit from "./ItemMasterEdit";
import ItemMasterView from "./ItemMasterView";
import ReactPaginate from "react-paginate";
import DeleteItemMaster from "./DeleteItemMaster";
import ItemMasterActive from "./ItemMasterActive";

import Select from "react-dropdown-select";

import "../Common/Common.css";
var dateFormat = require("dateformat");

class ItemMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showitemmasterAddModel: false,
      showitemmasterEditModel: false,
      ItemMasterShow: false,
      showItemMasterDelModel: false,
      page: 0,
      perPage: 10,
      ItemMasterdtList: "",
      searchItemMaster: "",
      showPatientsorderActive: false,
      filterValue: "",
      brandId: "",
    };
  }

  componentDidMount() {
    this.props.fetchItemMaster({
      pageno: undefined,
      search: this.state.searchItemMaster,
      filter: this.state.filterValue,
      brandId: this.state.brandId,
    });
    this.props.fetchBrand();
    this.props.fetchUnit();
    this.props.fetchMedicalType();
    this.props.fetchAllbrands();
  }

  handleAdditemmaster = () => {
    this.setState({
      showitemmasterAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showitemmasterAddModel: false,
    });
  };

  handleEditItemMaster = (item) => {
    this.setState({
      showitemmasterEditModel: true,
      ItemMasterdtList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showitemmasterEditModel: false,
    });
  };

  handleItemMasterView = (item) => {
    this.setState({
      ItemMasterShow: true,
      ItemMasterDtls: item,
    });
  };

  handleCloseItemMaster = () => {
    this.setState({ ItemMasterShow: false });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.ItemMasterSlectedPage({
      pageno: selectedPage + 1,
      search: this.state.searchItemMaster,
      filter: this.state.filterValue,
      brandId: this.state.brandId,
    });
    this.setState({ page: selectedPage });
  };
  resetPage = () => {
    this.setState({ page: 0 });
  };

  handleDelItemMaster = (item) => {
    this.setState({
      showItemMasterDelModel: true,
      DeleteItemMaster: item,
    });
  };
  closeItemMasterDelModel = () => {
    this.setState({
      showItemMasterDelModel: false,
    });
  };

  handlePatientsorderActiveView = (item) => {
    this.setState({
      showPatientsorderActive: true,
      ItemMasterActiveActvDtls: item,
    });
  };
  handleCloseActive = () => {
    this.setState({ showPatientsorderActive: false });
  };

  SearchOnChange = (event) => {
    this.setState(
      {
        filterValue: this.state.filterValue,
        searchItemMaster: event.target.value,
        page: 0,
        brandId: this.state.brandId,
      },
      () => {
        this.props.fetchItemMaster({
          pageno: undefined,
          search: this.state.searchItemMaster,
          filter: this.state.filterValue,
          brandId: this.state.brandId,
        });
      }
    );
  };

  handleChange = (event) => {
    this.setState(
      {
        page: 0,
        filterValue: event.target.value,
        searchItemMaster: this.state.searchItemMaster,
        brandId: this.state.brandId,
      },
      () => {
        this.props.fetchItemMaster({
          pageno: undefined,
          search: this.state.searchItemMaster,
          filter: this.state.filterValue,
          brandId: this.state.brandId,
        });
      }
    );
  };

  filterbyBrand = (value) => {
    console.log(value);

    this.setState(
      {
        page: 0,
        filterValue: this.state.filterValue,
        searchItemMaster: this.state.searchItemMaster,
        brandId: value.length === 0 ? "" : value[0].id,
      },
      () => {
        this.props.fetchItemMaster({
          pageno: undefined,
          search: this.state.searchItemMaster,
          filter: this.state.filterValue,
          brandId: this.state.brandId,
        });
      }
    );
  };

  render() {
    let p = this.state.page + 1;
    const count =
      this.props.ItemMasterDtlsCount && this.props.ItemMasterDtlsCount;
    let ItemMasterPageCount = Math.ceil(count / this.state.perPage);

    return (
      console.log(this.props.BrandList),
      console.log(this.props.allBrands),
      (
        <div>
          <Card>
            <Card.Header className="d-flex flex-column" style={{ gap: "5px" }}>
              <Row className="tableHeaderRow">
                <Col xs={12} sm={12} md={3} lg={3}>
                  <h3>Item Master</h3>
                </Col>

                <Col xs={12} sm={12} md={3} lg={3}>
                  <div className="commonFilterDiv">
                    <select
                      value={this.state.filterValue}
                      onChange={this.handleChange}
                      className="commonFilterSelect"
                    >
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="suspended">Suspended</option>
                    </select>
                  </div>
                </Col>

                <Col xs={12} sm={12} md={3} lg={3}>
                  <div>
                    <div className="commonInput">
                      <i className="fa fa-search fa-lg cmnSearchIcon"></i>
                      <input
                        type="text"
                        placeholder="Item Code"
                        value={this.state.searchItemMaster}
                        onChange={this.SearchOnChange}
                      />
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <div className="commonRecrd">
                    <i className="cui-note icons cmnRecordIcon"></i>
                    <span className="cmnPageCount">
                      {count === undefined ? 0 : count}
                    </span>
                    <span className="cmnResutText">Results</span>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xs={12} sm={12} md={3} lg={3}></Col>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <div className="commonFilterDiv">
                    <Select
                      placeholder="Filter by brand"
                      options={this.props.allBrands}
                      closeOnSelect={true}
                      sortBy="label"
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      onChange={(values) => this.filterbyBrand(values)}
                    />
                  </div>
                </Col>
                <Col xs={12} sm={12} md={3} lg={3}></Col>
                <Col xs={12} sm={12} md={3} lg={3}></Col>
              </Row>
            </Card.Header>
            <Card.Body>
              <div>
                <Button
                  style={{ marginBottom: "15px" }}
                  onClick={() => this.handleAdditemmaster()}
                >
                  <i className="fa fa-plus fa-md"></i>
                  <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                    ADD
                  </span>
                </Button>
                <ItemMasterAdd
                  showitemmasterAddModel={this.state.showitemmasterAddModel}
                  closeAddModel={this.closeAddModel}
                  AddItemMaster={this.props.AddItemMaster}
                  BrandList={this.props.BrandList}
                  UnitList={this.props.UnitList}
                  MedicalTypeList={this.props.MedicalTypeList}
                  resetPage={this.resetPage}
                />
              </div>
              <div>
                <Table responsive bordered striped className="cmnMainTable">
                  <thead>
                    <tr className="cmnMainTableHd">
                      <th>SL NO</th>
                      <th> BRAND </th>
                      <th> ITEM CODE </th>
                      <th> ITEM NAME </th>
                      <th> BATCH </th>
                      <th> UNIT </th>
                      <th> PRICE </th>
                      <th>CREATED DATE</th>
                      <th>ITEM STATUS</th>
                      <th>BRAND STATUS</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.ItemMasterDtlsList &&
                      this.props.ItemMasterDtlsList.map((item, i) => (
                        <tr key={i}>
                          <td className="cmn_Cap">{10 * (p - 1) + i + 1}</td>

                          <td className="cmn_Cap">
                            {" "}
                            {item !== null &&
                              item.brand !== undefined &&
                              item.brand &&
                              item.brand.name}
                          </td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.drugCode}
                          </td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.drugName}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.batchNo}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null &&
                              item.unitMeasure !== undefined &&
                              item.unitMeasure &&
                              item.unitMeasure.name}
                          </td>
                          <td className="cmn_Cap">
                            {item !== null && item.unitPrice}
                          </td>
                          <td className="cmn_Cap">
                            {item.createdAt !== null &&
                              dateFormat(item.createdAt, "mediumDate")}
                          </td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.status}
                          </td>
                          <td className="cmn_Cap">
                            {" "}
                            {item !== null && item.disabled
                              ? "Disabled"
                              : "Active"}
                          </td>
                          <td className="cmnViewIcon">
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <i
                                className="fa fa-eye fa-lg "
                                onClick={() =>
                                  this.handleItemMasterView({ item: item })
                                }
                              ></i>

                              {item !== null && item.disabled ? (
                                <i
                                  className="fa fa-edit fa-lg"
                                  style={{
                                    paddingLeft: 10,
                                    color: "gray",
                                    cursor: "not-allowed",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="fa fa-edit fa-lg "
                                  style={{
                                    paddingLeft: 10,
                                  }}
                                  onClick={() =>
                                    this.handleEditItemMaster(item)
                                  }
                                ></i>
                              )}

                              {/* <i
                                className="fa fa-trash fa-lg"
                                style={{
                                  paddingLeft: 10,
                                }}
                                onClick={() => this.handleDelItemMaster(item)}
                              ></i> */}
                              <DeleteItemMaster
                                showItemMasterDelModel={
                                  this.state.showItemMasterDelModel
                                }
                                closeItemMasterDelModel={
                                  this.closeItemMasterDelModel
                                }
                                DeleteItemMaster={this.state.DeleteItemMaster}
                                ItemMasterDelete={this.props.ItemMasterDelete}
                                resetPage={this.resetPage}
                              />
                              {item !== null && item.disabled ? (
                                <i
                                  className="fa fa-ban fa-lg"
                                  style={{
                                    paddingLeft: 10,
                                    color: "gray",
                                    cursor: "not-allowed",
                                  }}
                                ></i>
                              ) : (
                                <i
                                  className="fa fa-ban fa-lg"
                                  style={{ paddingLeft: 10 }}
                                  onClick={() =>
                                    this.handlePatientsorderActiveView({
                                      item: item,
                                    })
                                  }
                                ></i>
                              )}
                              <ItemMasterActive
                                show={this.state.showPatientsorderActive}
                                handleClose={this.handleCloseActive}
                                ItemMasterActiveActvDtls={
                                  this.state.ItemMasterActiveActvDtls
                                }
                                ItemMasterInActive={
                                  this.props.ItemMasterInActive
                                }
                                resetPage={this.resetPage}
                              />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>

                <ItemMasterView
                  show={this.state.ItemMasterShow}
                  handleClose={this.handleCloseItemMaster}
                  ItemMasterDtls={this.state.ItemMasterDtls}
                />
                <ItemMasterEdit
                  showitemmasterEditModel={this.state.showitemmasterEditModel}
                  closeEditModel={this.closeEditModel}
                  ItemMasterdtList={this.state.ItemMasterdtList}
                  BrandList={this.props.BrandList}
                  UnitList={this.props.UnitList}
                  MedicalTypeList={this.props.MedicalTypeList}
                  EditItemmaster={this.props.EditItemmaster}
                  resetPage={this.resetPage}
                />

                {(this.props.ItemMasterDtlsList === undefined ||
                  (this.props.ItemMasterDtlsList &&
                    this.props.ItemMasterDtlsList.length === 0)) && (
                  <div>
                    <div className="noDataImgDiv">
                      <Image
                        className="noDataImg"
                        src={require("../../assets/img/nodata4.png")}
                      />
                    </div>
                    <div className="noDataTextDiv">No Items Found</div>
                  </div>
                )}
              </div>
            </Card.Body>
            {ItemMasterPageCount > 1 ? (
              <div className="paginationDiv">
                <ReactPaginate
                  forcePage={this.state.page}
                  previousLabel={"Prev"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={ItemMasterPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination flex-wrap"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            ) : null}
          </Card>
        </div>
      )
    );
  }
}
export default ItemMaster;
